/**
 * Instagram Feed component
 */

// Import statements
import React from "react"
import {GatsbyImage} from "gatsby-plugin-image";
import useInstagram from "../../hooks/useInstagram"

/**
 * Create non-page component
 * @returns {JSX.Element}
 * @constructor
 */
const InstagramFeed = () => {

    // get all instagram photos
    const instaPhotos = useInstagram()

    // parse JSX and return
    return (
        <div id="instagram_feed">
            <h4>Inspiratie</h4>
            <div className="row">
                <div className="col-12">
                    {instaPhotos.map((photo, index) => (
                        <a href={`${photo.permalink}`} className="instagram-square" rel="noopener noreferrer"
                           key={photo.id}>
                            <GatsbyImage image={photo.image} alt={photo.caption}/>
                        </a>
                    ))}
                </div>
                <div className="col-12">
                    <p>
                        <a id="instagram" href="https://www.instagram.com/myfoodblog_nl/"
                           className="btn btn-tertiary btn-sm">
                            <span className="icon icon-instagram-1"></span>Volg myfoodblog_nl
                            <span className="icon icon-plus"></span>
                        </a>
                    </p>
                </div>
            </div>
        </div>
    )
}

/**
 * Export non-page constant
 */
export default InstagramFeed
